import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=2e47e2e4&scoped=true&"
import script from "./AdminDetail.vue?vue&type=script&lang=js&"
export * from "./AdminDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetail.vue?vue&type=style&index=0&id=2e47e2e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47e2e4",
  null
  
)

export default component.exports